// extracted by mini-css-extract-plugin
export default {"practiceTimeList":"practiceTime_practiceTimeList__Gpc4V","emptyWrapper":"practiceTime_emptyWrapper__DArrc","emptyTitle":"practiceTime_emptyTitle__OkyIr"};